package top.wcpe.allincore.ui.web.model

import kotlin.js.Promise

internal fun interface ThreeModuleLoader {
    fun load(): Promise<dynamic>
}

internal class SharedThreeModuleLoader(
    private val importer: () -> Promise<dynamic>,
) : ThreeModuleLoader {
    private var sharedPromise: Promise<dynamic>? = null

    override fun load(): Promise<dynamic> {
        sharedPromise?.let { return it }
        return runCatching(importer).getOrElse(::rejectedPromise).also { sharedPromise = it }
    }
}

private val productionThreeModuleLoader = SharedThreeModuleLoader(::importThreeModule)

internal fun defaultThreeModuleLoader(): ThreeModuleLoader = productionThreeModuleLoader

private fun importThreeModule(): Promise<dynamic> = js("import('three')")

private fun rejectedPromise(error: Throwable): Promise<dynamic> = Promise { _, reject -> reject(error) }
